const styles = {
    editBox: {
        marginBottom: 30,
        paddingBottom: 30
    }
};

export default styles;



// WEBPACK FOOTER //
// src/containers/push/AddPushGroupPage/AddPushGroupPage.css.js